<template>
  <a :href="link" class="kt-portlet kt-iconbox" :class="animationClass">
    <div class="kt-portlet__body">
      <div class="kt-iconbox__body">
        <div class="kt-iconbox__icon">
          <template v-if="icon === 'wrench'">
            <i class="fa fa-wrench"></i>
          </template>
          <template v-else-if="icon === 'tablet'">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect id="bound" x="0" y="0" width="24" height="24"/>
                <path
                  d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                  id="Combined-Shape" fill="#000000" opacity="0.3"/>
                <path
                  d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
                  id="check-path" fill="#000000"/>
                <path
                  d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                  id="Combined-Shape" fill="#000000"/>
              </g>
            </svg>
          </template>
          <template v-else-if="icon === 'user'">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon id="Shape" points="0 0 24 0 24 24 0 24"/>
                <path
                  d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                  id="Mask" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
                <path
                  d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                  id="Mask-Copy" fill="#000000" fill-rule="nonzero"/>
              </g>
            </svg>
          </template>
          <template v-else-if="icon">
            <i :class="icon"></i>
          </template>
        </div>
        <div class="kt-iconbox__desc">
          <h3 class="kt-iconbox__title">
            {{ name }}
          </h3>
          <div class="kt-iconbox__content">
            {{ description }}
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
    name: 'ActionBoxLink',
    computed: {
        animationClass() {
            return {
                'kt-iconbox--animate-slow': this.speed === 'slow',
                'kt-iconbox--animate': this.speed === 'normal',
                'kt-iconbox--animate-fast': this.speed === 'fast',
            };
        },
        link() {
            let link = this.full

            if (window.innerWidth < 700) {
                link = this.mobile
            }

            return link
        }
    },
    props: {
        icon: String,
        name: String,
        description: String,
        mobile: String,
        full: String,
        speed: String,
    },
};
</script>

<style lang="scss">
  .kt-iconbox {
    &:hover {
      background: #c0c7fd;
    }

    .fa {
      font-size: 40px;
    }

    .kt-iconbox__icon {
      font-size: 40px;
    }
  }
</style>
